module.exports = __webpack_public_path__ + "static/media/zebra.e3a8fbeb.jpg";